import React, {ReactNode} from 'react';
import {Checkbox, FormHelperText, InputLabel, MenuItem, Select, SelectChangeEvent, Stack} from '@mui/material';

import {ArrowDown} from '@icons/index';
import {SelectItem} from '@components/inputs/select/Select.component';
import {Colors} from '@constants/colors.constants';

interface SelectComponentProps {
  color?: 'primary' | 'secondary';
  disabled?: boolean;
  error?: string;
  handleChange?: (values: any[]) => void;
  inputWidth?: number;
  items?: SelectItem[];
  label?: string;
  labelWidth?: number;
  placeholder?: string;
  readOnly?: boolean;
  required?: boolean;
  size?: 'small';
  values?: any[];
  forceRenderValue?: boolean;
  renderValue?: (values: any[]) => ReactNode | undefined;
  forceBackgroundColor?: boolean;
}

const MultiSelectComponent = (props: SelectComponentProps) => {
  const {
    color = 'primary',
    disabled,
    error,
    handleChange,
    inputWidth,
    items,
    label,
    labelWidth,
    placeholder,
    readOnly,
    required,
    size,
    values = [],
    forceBackgroundColor,
    renderValue,
  } = props;


  return (
      <Stack direction="row" justifyContent="space-between" spacing={2}>
        {!!label && (
            <InputLabel error={!!error && !disabled} sx={{width: labelWidth ? `${labelWidth}px` : undefined}}>
              {label + (required ? '*' : '')}
            </InputLabel>
        )}
        <Stack flex={!inputWidth ? 1 : undefined}>
          <Select
              // SelectDisplayProps={{
              //   style: {
              //     cursor: readOnly ? 'default' : undefined,
              //     backgroundColor: currentItem?.backgroundColor,
              //   }
              // }}
              IconComponent={!readOnly
                  ? (params) => <ArrowDown {...params}/>
                  : () => null
              }
              color={color}
              multiple
              sx={{flex: 1, width: inputWidth ? `${inputWidth}px` : undefined, backgroundColor: forceBackgroundColor ? Colors.background: ''}}
              onChange={(evt: SelectChangeEvent<string[]>) => handleChange?.(evt.target.value as string[])}
              required={required}
              disabled={disabled}
              readOnly={readOnly}
              label={placeholder}
              MenuProps={{
                'aria-label': size,
              }}
              size={size}
              value={values ?? ''}
              renderValue={(selected) => {
                const sel = selected as any[];
                if (renderValue) return renderValue(sel);
                if (!sel.length) return <span style={{opacity: 0.5}}>{placeholder}</span>;
                return `${placeholder} (${sel.length})`;
              }}>
            {!readOnly && placeholder && (
                <MenuItem value="">{placeholder}</MenuItem>
            )}
            {items?.map((item) => {
              return (<MenuItem
                  key={`${item.label} ${item.value}`}
                  value={item.value}
                  style={{backgroundColor: item.backgroundColor}}
              >
                <Checkbox checked={values.indexOf(item.value) > -1}/>
                {item.label}
              </MenuItem>);

            })}
          </Select>
          {!!error && !disabled && <FormHelperText error sx={{mx: '14px'}}>{error}</FormHelperText>}
        </Stack>
      </Stack>
  );
};

export default MultiSelectComponent;
